module.exports = __webpack_public_path__ + "static/img/home_bg.bff8fc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/home_bg.png
// module id = I/ig
// module chunks = 8